var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ResponseModel } from "@/models/ResponseModel";
import { BaseService } from "../BaseService";
var GatewayService = /** @class */ (function (_super) {
    __extends(GatewayService, _super);
    function GatewayService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GatewayService.prototype.criarProtocolo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.post("/protocolos/criar")];
            });
        });
    };
    GatewayService.prototype.locaisRecebimento = function () {
        return __awaiter(this, void 0, Promise, function () {
            var ret;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.get("/site/locaisRecebimento")];
                    case 1:
                        ret = _a.sent();
                        return [2 /*return*/, ret.data];
                }
            });
        });
    };
    GatewayService.prototype.download = function (data) {
        return __awaiter(this, void 0, Promise, function () {
            var ret;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.post("/site/downloadFile", data)];
                    case 1:
                        ret = _a.sent();
                        return [2 /*return*/, ret.data];
                }
            });
        });
    };
    GatewayService.prototype.consultarCep = function (cep) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.api
                            .get("/site/renavam/consultar-cep/" + cep.replace(/[^0-9]/g, ""))
                            .then(function (r) {
                            resolve(r.data);
                        })
                            .catch(function (e) {
                            var _a;
                            resolve(((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) || (e === null || e === void 0 ? void 0 : e.response) || e);
                        });
                    })];
            });
        });
    };
    GatewayService.prototype.consultarUf = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.api
                            .get("/site/renavam/tabela/uf")
                            .then(function (r) {
                            resolve(r.data);
                        })
                            .catch(function (e) {
                            var _a;
                            resolve(((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) || (e === null || e === void 0 ? void 0 : e.response) || e);
                        });
                    })];
            });
        });
    };
    GatewayService.prototype.consultarMunicipio = function (uf) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.api
                            .get("/site/renavam/tabela/municipios/" + uf)
                            .then(function (r) {
                            resolve(r.data);
                        })
                            .catch(function (e) {
                            var _a;
                            resolve(((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) || (e === null || e === void 0 ? void 0 : e.response) || e);
                        });
                    })];
            });
        });
    };
    GatewayService.prototype.consultaVeiculo = function (placa, renavam) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.api
                            .get("/site/renavam/consulta-veiculo-extendido?placa=".concat(placa
                            .replace(/[^0-9A-Za-z]/g, "")
                            .toUpperCase(), "&renavam=").concat(renavam))
                            .then(function (r) {
                            resolve(r.data);
                        })
                            .catch(function (e) {
                            var _a;
                            resolve(((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) || (e === null || e === void 0 ? void 0 : e.response) || e);
                        });
                    })];
            });
        });
    };
    GatewayService.prototype.obterCrlve = function (placa) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.api
                            .get("/site/renavam/obter-crlve/".concat(placa
                            .replace(/[^0-9A-Za-z]/g, "")
                            .toUpperCase()))
                            .then(function (r) {
                            resolve(r.data);
                        })
                            .catch(function (e) {
                            var _a;
                            resolve(((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) || (e === null || e === void 0 ? void 0 : e.response) || e);
                        });
                    })];
            });
        });
    };
    GatewayService.prototype.obterCrv = function (atendimento, placa) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.api
                            .get("/site/renavam/consulta-atendimento-2-via-crv/".concat(atendimento, "/").concat(placa
                            .replace(/[^0-9A-Za-z]/g, "")
                            .toUpperCase()))
                            .then(function (r) {
                            resolve(r.data);
                        })
                            .catch(function (e) {
                            var emptyResponse = new ResponseModel();
                            emptyResponse.data = {};
                            resolve(emptyResponse);
                        });
                    })];
            });
        });
    };
    GatewayService.prototype.consultarAndamentoProcesso = function (idAtendimento, recaptchaToken) {
        return __awaiter(this, void 0, Promise, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._api.get("/site/renavam/consulta-andamento-processo/".concat(idAtendimento), {
                            headers: {
                                "X-Recaptcha-Token": recaptchaToken,
                            },
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GatewayService.prototype.consultarHistoricoProcesso = function (placa, renavam) {
        return __awaiter(this, void 0, Promise, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._api.get("/site/renavam/historico-processos-veicular/".concat(renavam, "/").concat(placa
                            .replace(/[^0-9A-Za-z]/g, "")
                            .toUpperCase()))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GatewayService.prototype.consultarHistoricoProcesso2 = function (placa, atendimento, recaptchaToken) {
        return __awaiter(this, void 0, Promise, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._api.get("/site/renavam/historico-processos-veicular?placa=".concat(placa
                            .replace(/[^0-9A-Za-z]/g, "")
                            .toUpperCase(), "&atendimento=").concat(atendimento), {
                            headers: {
                                "X-Recaptcha-Token": recaptchaToken,
                            },
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GatewayService.prototype.solicitarSegundaViaCrv = function (dto) {
        return __awaiter(this, void 0, Promise, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._api.post("/site/renavam/obter-2-via-crv", dto)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.data];
                }
            });
        });
    };
    return GatewayService;
}(BaseService));
export default GatewayService;
